import React from "react";
import { WalletOutlined } from "@ant-design/icons";
import { formatMoney } from "../../utils/formatUtils";
import { getCurrencyTheme } from "../../utils/themeUtils";

export function WalletCard({
  currency,
  walletBalance,
  totalBalance,
  accountCount,
  active = false,
  onClick,
}) {
  const theme = getCurrencyTheme(currency);

  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "group relative shrink-0 overflow-hidden rounded-2xl border text-left transition-all duration-200",
        "hover:-translate-y-0.5 hover:shadow-lg",
        active ? "shadow-md" : "shadow-sm",
        "w-[313.5px]",
        "h-[190px]",
      ].join(" ")}
      style={{
        backgroundColor: theme.bg,
        borderColor: active ? theme.accent : theme.border,
        color: theme.text,
        outline: active ? `2.5px solid ${theme.accent}` : "none",
        outlineOffset: "2px",
      }}
    >
      {/* Gradient shimmer */}
      <div
        className="pointer-events-none absolute inset-0 opacity-20"
        style={{
          background:
            "radial-gradient(circle at top right, rgba(255,255,255,0.9), transparent 32%), radial-gradient(circle at bottom left, rgba(255,255,255,0.55), transparent 28%)",
        }}
      />

      <div className="relative flex flex-col gap-3 p-4">
        {/* Header row: currency name + wallet icon */}
        <div className="flex items-center justify-between gap-2">
          <div className="text-[26px] font-bold leading-none tracking-tight">
            {currency}
          </div>
          <div
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-white"
            style={{ backgroundColor: theme.iconBg }}
          >
            <WalletOutlined className="text-[14px]" />
          </div>
        </div>

        {/* Wallet balance — hero number */}
        <div>
          <div
            className="mb-0.5 text-[9px] font-medium uppercase tracking-[0.18em]"
            style={{ color: theme.muted }}
          >
            Хийсвэр үлдэгдэл
          </div>
          <div className="break-all text-[16px] font-semibold leading-snug">
            {formatMoney(walletBalance ?? 0, currency)}
          </div>
        </div>

        {/* Bottom row: real balance + account count */}
        <div
          className="flex items-end justify-between border-t pt-2"
          style={{ borderColor: "rgba(0,0,0,0.08)" }}
        >
          <div>
            <div
              className="mb-0.5 text-[9px] uppercase tracking-[0.14em]"
              style={{ color: theme.muted }}
            >
              Жинхэнэ
            </div>
            <div
              className="text-[13px] font-medium"
              style={{ color: theme.muted }}
            >
              {formatMoney(totalBalance ?? 0, currency)}
            </div>
          </div>
          <div className="text-right">
            <div
              className="mb-0.5 text-[9px] uppercase tracking-[0.14em]"
              style={{ color: theme.muted }}
            >
              Данс
            </div>
            <div className="text-[15px] font-semibold">{accountCount ?? 0}</div>
          </div>
        </div>
      </div>

      {/* Active bottom bar */}
      {active ? (
        <div
          className="absolute bottom-0 left-0 right-0 h-[3px] rounded-b-2xl"
          style={{ backgroundColor: theme.accent }}
        />
      ) : null}
    </button>
  );
}

export default WalletCard;
